import * as React from "react";
import YouTube from 'react-youtube';

export interface QuestionProps{
    setAnswer:(e:boolean)=>void,
    setVideoLoaded:()=>void,
    answers:{'y':string,'n':string},
    questionNumber:number,
    videoId:string,
    answerCorrectness:string,
    hideVideo:boolean
}

interface QuestionState {
    player:any,
    showBtns:boolean,
    btnsOrder:number,
    inited:boolean,
    played:boolean
}

export class Question extends React.Component<QuestionProps,QuestionState>{
    constructor(props){
        super(props);
        this.state={
            player:null,
            inited:false,
            played:false,
            showBtns:false,
            btnsOrder:Math.floor(Math.random() * 2)
        };
        this.setAnswer  = this.setAnswer.bind(this);

        this.startV     = this.startV.bind(this)
        this.startPlay     = this.startPlay.bind(this)
    }

    private setAnswer(answer,e) {
        //this.state.player.target.playVideo();
        this.props.setAnswer(answer);
    }



    private getBtn(correctness:string) {
        return (
            <div
                className={'button _answer'}
                onClick={this.setAnswer.bind(this,correctness)}>
                {this.props.answers[correctness]}
            </div>
        );
    }
    componentDidMount() {
        /*        let audioPlayer: any = document.getElementById('vid');
                audioPlayer.load();
                audioPlayer.play();*/

    }
    componentDidUpdate() {
  /*      let audioPlayer: any = document.getElementById('vid');
        audioPlayer.load();
        audioPlayer.play();*/
        if(this.state.player) {
            if (this.props.hideVideo) {
                this.state.player.target.pauseVideo();
            }
        }
        if(this.state.player && !this.state.played) {
            if (!this.props.hideVideo) {
                //alert('play video' + this.props.questionNumber);
                console.log('play video ' + this.props.questionNumber);
                this.state.player.target.playVideo();


            }
        }
    }
    pauseV(event) {
        //alert('paused');
    }
    endV(event) {
        //alert('ended1');
        let duration:number = event.target.getDuration();
        event.target.seekTo(duration-1,true);
        //event.target.pauseVideo(); //с паузой показывает предложения
        event.target.stopVideo();
    }
    startPlay(event) {
        console.log('started');
        if(!this.state.played) {
            this.setState({played:true});
            setTimeout(
                function () {
                    this.setState({showBtns: true});
                }.bind(this),
                22000
            );
        }
    }
    startV(event) {
        if(this.state.player==null) {
            this.setState({
                player: event
            });
            console.log('video ' + this.props.questionNumber + ' loaded');
        }
        this.props.setVideoLoaded();

        //alert('video ' + this.props.questionNumber + ' loaded');
        //console.log( event);
    }
    render() {
        let vw:number = window.innerWidth;
        let vh:number = window.innerHeight;
        let videoHeight:number;
        if(vw<900){//mobile
            videoHeight = vw;
            /*if(vh*.4>vw) {
                videoHeight=vw;
            } else {
                videoHeight=vh*.4;
            }*/
        } else {
            videoHeight =  +window.getComputedStyle(document.querySelector('html'), null).getPropertyValue('font-size').slice(0,-2)*48.938;
        }
        const opts = {
            height: videoHeight,
            width: videoHeight,
            allowFullScreen: false,
            doNotAllowFullScreen: '1',
            donotallowfullscreen: '1',
            playerVars: { // https://developers.google.com/youtube/player_parameters
                controls:0,
                showinfo:0,
                iv_load_policy:3,
                fs:0,
                disablekb:1,
                modestbranding:1,
                rel:0,
                autoplay:0,
                playsinline:1
            }
        };
        let btns = this.state.btnsOrder === 1 ?
            (<div>{this.getBtn('y')}{this.getBtn('n')}</div>)
            :
            (<div>{this.getBtn('n')}{this.getBtn('y')}</div>)
        let btnsBlock = (
            <div className={'answer-buttons' + (this.state.showBtns ? '' : ' _transparent')}>
                <div className={'answer-buttons__title'}>Угадай, сколько стоит?</div>
                {btns}
            </div>
        );
        return (
            <div>
                <div className={'frame' + (this.props.hideVideo ? ' _hidden' : '')}>
                    <YouTube videoId={this.props.videoId} opts={opts} onPause={this.pauseV.bind(this)} onPlay={this.startPlay.bind(this)} onEnd={this.endV.bind(this)} onReady={this.startV.bind(this)}/>
                    {/*<iframe id='vid' width="345" height="373" src="https://www.youtube.com/embed/M2iRGfPZdFY?controls=0&autoplay=1&rel=0&showinfo=0&iv_load_policy=3&fs=0&disablekb=1&modestbranding=1"
                            frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen></iframe>*/}
                    {btnsBlock}
                </div>
            </div>
        );
    }
}